import classNames from "classnames";
import { CardVariant, MDOption, MetadataType } from "types";
import HeaderTitle from "./HeaderTitle";
import CardMetadataLabels from "views/components/CardMetadataLabels";
import styles from "./style.module.scss";
import { ReactNode } from "react";

export interface CardHeaderProps {
  debugInfo?: string;
  cardVariant: CardVariant;
  selectedLabels: any;
  mdOptions: MDOption[];
  prefix: React.ReactNode;
  suffix?: { tooltipText: string; icon: ReactNode };
  cardMdType: MetadataType;
  mdLabels: string[] | null;
  title: string | JSX.Element;
  selectedMdIcon: JSX.Element;
  onMDLabelSelection?: (label: string) => void;
  showMdSelector?: boolean;
}

const CardHeader = ({
  title,
  cardVariant,
  mdLabels,
  mdOptions,
  prefix,
  suffix,
  debugInfo,
  cardMdType,
  selectedLabels,
  selectedMdIcon,
  onMDLabelSelection,
  showMdSelector = true,
}: CardHeaderProps) => {
  const cardHeadClassnames = classNames(styles.cardHead, {
    [styles.unClickable]: cardVariant === CardVariant.VERTEX,
  });

  return (
    <div className={cardHeadClassnames}>
      {title && (
        <HeaderTitle
          title={title}
          prefix={prefix}
          debugInfo={debugInfo}
          cardVariant={cardVariant}
          suffix={title ? suffix : undefined}
        />
      )}
      {showMdSelector && (
        <>
          {mdLabels ? (
            <CardMetadataLabels
              labels={mdLabels}
              options={mdOptions}
              metadataType={cardMdType}
              cardVariant={cardVariant}
              labelIcon={selectedMdIcon}
              selectedLabels={selectedLabels}
              onLabelSelection={onMDLabelSelection}
              suffix={!title ? suffix : undefined}
            />
          ) : (
            <div className={styles.lowerRow}>
              <div
                className={styles.previewLoader}
                data-testid="preview-loader"
              ></div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default CardHeader;
